import { call, takeEvery, takeLatest } from 'redux-saga/effects';

import actions from '../../actions';
import {
  setOrganizationId,
  setInvitedUserOrganizationId,
} from '../../effects/organization';
import updateOrganizationName from './updateOrganizationName';
import getOrganizationDetails from './getOrganizationDetails';
import createOrganization from './createOrganization';
import createContract from './contracts/createContract';
import getBillingDetails from './billing/getBillingDetails';
import verifyBankAccount from './bankAccounts/verifyBankAccount';
import getPaymentSources from './billing/getPaymentSources';
import deletePaymentSource from './billing/deletePaymentSource';
import getContracts from './contracts/getContracts';
import getApplications from './applications/getApplications';
import getDiscounts from './discounts/getDiscounts';
import getSecretKeyCommunication from './applications/getSecretKeyCommunication';
import resetSetSecretKeyCommunication from './applications/resetSetSecretKeyCommunication';
import getMediaSecretKeyCommunication from './applications/getMediaSecretKeyCommunication';
import resetSetMediaSecretKeyCommunication from './applications/resetSetMediaSecretKeyCommunication';
import createApplication from './applications/createApplication';
import updateApplication from './applications/updateApplication';
import deleteApplication from './applications/deleteApplication';
import getInvoices from './invoices/getInvoices';
import getUsers from './users/getUsers';
import inviteUser from './users/inviteUser';
import deleteUser from './users/deleteUser';
import updateCustomer from './contracts/updateCustomer';
import getProfile from './profile/getProfile';
import updateProfile from './profile/updateProfile';
import createBilling from './billing/createBilling';
import setDefaultAccount from './billing/setDefaultAccount';
import updateBilling from './billing/updateBilling';
import updateUsage from './usage/updateUsage';

import getWebhooksEvents from './applications/getWebhooksEvents';
import getIntegrations from './integrations/getIntegrations';
import removeIntegration from './integrations/removeIntegration';
import addIntegration from './integrations/addIntegration';

export function* subscription() {
  yield call(createContract);
  // yield call(getBillingDetails)
  yield call(getOrganizationDetails);
}

export function* editBilling() {
  yield call(updateCustomer);
  yield call(getPaymentSources);
}

export function* setDefaultAccountFlow({ payload }) {
  yield call(setDefaultAccount, payload);
}

export function* deletePaymentSourceFlow({ payload }) {
  yield call(deletePaymentSource, payload);
  yield call(getPaymentSources);
}

export function* verifyBankAccountFlow({ payload: { id, amounts } }) {
  yield call(verifyBankAccount, { id, amounts });
}

export function* identifyUserFlow() {
  yield call(getProfile);
  yield call(getUsers);
}

export default function* organizationFlow() {
  yield takeEvery(
    actions.organization.updateOrganizationName,
    updateOrganizationName,
  );
  yield takeEvery(actions.organization.createOrganization, createOrganization);
  yield takeEvery(actions.organization.createApplication, createApplication);
  yield takeEvery(actions.organization.updateApplication, updateApplication);
  yield takeEvery(actions.organization.updateProfile, updateProfile);
  yield takeEvery(actions.organization.deleteApplication, deleteApplication);
  yield takeEvery(
    actions.organization.setDefaultAccount,
    setDefaultAccountFlow,
  );
  yield takeEvery(
    actions.organization.deletePaymentSource,
    deletePaymentSourceFlow,
  );
  yield takeEvery(actions.organization.updateBilling, updateBilling);
  yield takeEvery(actions.organization.createContract, subscription);
  yield takeEvery(
    actions.organization.verifyBankAccount,
    verifyBankAccountFlow,
  );
  yield takeEvery(actions.organization.updateCustomer, editBilling);
  yield takeEvery(
    actions.organization.getSecretKeyCommunication,
    getSecretKeyCommunication,
  );
  yield takeEvery(
    actions.organization.resetSecretKeyCommunication,
    resetSetSecretKeyCommunication,
  );
  yield takeEvery(
    actions.organization.getMediaSecretKeyCommunication,
    getMediaSecretKeyCommunication,
  );
  yield takeEvery(
    actions.organization.resetMediaSecretKeyCommunication,
    resetSetMediaSecretKeyCommunication,
  );
  yield takeEvery(actions.organization.updateUsage, updateUsage);
  yield takeLatest(actions.organization.createBilling, createBilling);
  yield takeEvery(actions.organization.getWebhooksEvents, getWebhooksEvents);
  yield takeEvery(setInvitedUserOrganizationId, getProfile);
  yield takeEvery(setOrganizationId, identifyUserFlow);
  yield takeEvery(setOrganizationId, getApplications);
  yield takeEvery(setOrganizationId, getDiscounts);
  yield takeEvery(setOrganizationId, updateUsage);
  yield takeEvery(setOrganizationId, getContracts);
  yield takeEvery(setOrganizationId, getBillingDetails);
  yield takeEvery(setOrganizationId, getInvoices);
  yield takeEvery(setOrganizationId, getPaymentSources);
  yield takeEvery(setOrganizationId, getIntegrations);
  yield takeEvery(actions.organization.removeIntegration, removeIntegration);
  yield takeEvery(actions.organization.addIntegration, addIntegration);
  yield takeEvery(actions.organization.inviteUser, inviteUser);
  yield takeEvery(actions.organization.deleteUser, deleteUser);
}
